import { useState } from "react";
// @mui
import { MenuItem, Stack } from "@mui/material";
// locales
import { useLocales } from "../../../locales";
// components
import Image from "../../../components/image";
import MenuPopover from "../../../components/menu-popover";
import { IconButtonAnimate } from "../../../components/animate";
import { Typography } from "@mui/material";
// ----------------------------------------------------------------------

export default function LanguagePopover() {
  const { languages, currentLang, onChangeLang } = useLocales();

  const [openPopover, setOpenPopover] = useState(null);

  const handleOpenPopover = (event) => {
    setOpenPopover(event.currentTarget);
  };

  const handleClosePopover = () => {
    setOpenPopover(null);
  };

  const handleChangeLang = (newLang) => {
    onChangeLang(newLang);
    handleClosePopover();
  };

  return (
    <>
      <IconButtonAnimate
        onClick={handleOpenPopover}
        sx={{
          width: 40,
          height: 40,
          ...(openPopover && {
            bgcolor: "action.selected",
          }),
        }}
      >
        <Typography variant="subtitle2" sx={{ textTransform: "uppercase" }}>
          {currentLang.lang_code}
        </Typography>
      </IconButtonAnimate>

      <MenuPopover
        open={openPopover}
        onClose={handleClosePopover}
        sx={{ width: 180 }}
      >
        <Stack spacing={0.75}>
          {languages.map((option) => (
            <MenuItem
              key={option.lang_code}
              selected={option.lang_code === currentLang.lang_code}
              onClick={() => handleChangeLang(option.lang_code)}
            >
              {/* <Image
                disabledEffect
                alt={option.name}
                src={option.icon}
                sx={{ width: 28, mr: 2 }}
              /> */}

              {option.name}
            </MenuItem>
          ))}
        </Stack>
      </MenuPopover>
    </>
  );
}
